import axios, { AxiosResponse } from 'axios'

import { PromotionCodeRead, PromotionCodeWrite } from '@generated/types'

const BASE_URL = '/api/promotion-code'

export default {
  async validate(code: string, performance_id: any): Promise<AxiosResponse> {
    return axios.get(`${BASE_URL}/validate/`, { params: { code, performance_id } })
  },

  async updateAll(data: PromotionCodeWrite[]): Promise<AxiosResponse> {
    return axios.put(`${BASE_URL}/all/`, data)
  },

  async fetchAll(): Promise<AxiosResponse<PromotionCodeRead[]>> {
    return axios.get(`${BASE_URL}/`)
  },
}
